module.exports = (__parcel__import__("kXfgb")).then(() => parcelRequire('fyWP3'));